<template>
  <div id="app">
    <div v-if="!isLogin" class="layoutCon">
      <div class="navCon">
        <nav-menu :menu-arr="menuArr"></nav-menu>
      </div>
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import navMenu from "./components/navMenu";
export default {
  name: "App",
  components: {
    navMenu,
  },
  data() {
    return {
      menuArr: [
        // {
        //   icon: "iconfont icon-a-ziyuan1",
        //   label: "消息管理",
        //   value: 0,
        //   children: [
        //     {
        //       label: "项目消息",
        //       value: 0,
        //       path: "ProjectMsg",
        //     },
        //     {
        //       label: "系统消息",
        //       value: 1,
        //       path: "System",
        //     },
        //   ],
        // },
        {
          icon: "iconfont icon-yonghuzhongxin",
          label: "用户中心",
          value: 1,
          children: [
            {
              label: "项目管理",
              value: 0,
              path: "Project",
            },
            {
              label: "作品管理",
              value: 1,
              path: "Works",
            },
            // {
            //   label: "客户管理",
            //   value: 2,
            //   path: "Customer",
            // },
            {
              label: "合同管理",
              value: 3,
              path: "Contract",
            },
            {
              label: "发票管理",
              value: 4,
              path: "Invoice",
            },
            // {
            //   label: "推广管理",
            //   value: 5,
            //   path: "Promotion",
            // },
            
            // {
            //   label: "客户分组",
            //   value: 6,
            //   path: "CustomerGroup",
            // },
            // {
            //   label: "空间管理",
            //   value: 7,
            //   path: "SpaceManage",
            // },
          ],
        },
        // {
        //   icon: "iconfont icon-caiwuguanli",
        //   label: "财务管理",
        //   value: 2,
        //   children: [
        //     {
        //       label: "财务管理",
        //       value: 0,
        //       path: "Financial",
        //     },
        //   ],
        // },
        {
          icon: "iconfont icon-zhanghaoshezhi",
          label: "账号设置",
          value: 3,
          children: [
            {
              label: "个人资料",
              value: 0,
              path: "PersonalData",
            },
            // {
            //   label: "账号认证",
            //   value: 1,
            //   path: "PasswordAuth",
            // },
            {
              label: "密码修改",
              value: 2,
              path: "PasswordModify",
            },
            {
              label: "账号绑定",
              value: 3,
              path: "AccountBind",
            },
          ],
        },
      ],
      showLoginBtn: true,
      showHeader: true,
      isLogin: false,
    };
  },
  computed: {
    activeIndex: {
      get() {
        return this.$store.state.activeIndex;
      },
      set(value) {
        this.$store.commit("changeActive", value);
      },
    },
  },
  watch: {
    $route(to) {
      console.log(to);
      const name = to.name;
      this.$store.commit("changeActive", to.meta.activeIndex);
      if (name === "Login" || name === "Register") {
        this.isLogin = true;
      } else {
        this.isLogin = false
      }
    },
  },
  mounted() {
    /* eslint-disable */
    console.log(encodeURIComponent("http://192.168.1.6:8081/"));
    const activeIndex = sessionStorage.getItem("activeIndex");
    if (activeIndex || activeIndex === 0)
      this.$store.commit("changeActive", +activeIndex);
  },
  methods: {
    // 切换tab
    changeTab(item) {
      this.$store.commit("changeActive", item.index);
      this.activeIndex = item.index;
      if (item.value) {
        this.$router.push({
          name: item.value,
        });
      }
    },
    // 登录页
    backToLogin() {
      this.$store.commit("changeActive", 0);
      this.$router.push({
        name: "Login",
      });
    },
    toRegister() {
      console.log(window.location.origin + "/#/register");
      window.open(window.location.origin + "/#/register", "register");
    },
    handleScroll() {
      const navbar = this.$refs.appTop;
      return debounce(() => {
        // 获取导航栏距离顶部的原始位置
        const navbarOffset = navbar.offsetTop;

        if (window.pageYOffset > navbarOffset) {
          navbar.classList.add("fixed");
        } else {
          navbar.classList.remove("fixed");
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
#app {
  .layoutCon {
    display: flex;
    .navCon {
      height: 100vh;
      min-height: 700px;
      ::-webkit-scrollbar {
        display: none; /* Chrome, Safari 和 Opera */
      }
    }
    .content {
      flex: 1;
      min-width: 800px;
      height: 100vh;
      min-height: 700px;
      padding: 22px;
      background: #f2f3f5;
      overflow: hidden;
      ::-webkit-scrollbar {
        width: 6px; /* 滚动条宽度 */
        height: 6px; /* 水平滚动条高度 */
      }

      ::-webkit-scrollbar-track {
        background: transparent; /* 滑轨完全透明 */
      }
      ::-webkit-scrollbar-thumb {
        background: rgba(128, 128, 128, 0.5); /* 半透明灰色滑块 */
        border-radius: 3px; /* 滑块圆角 */
      }

      ::-webkit-scrollbar-thumb:hover {
        background: rgba(85, 85, 85, 0.7); /* 悬停时滑块颜色加深 */
      }
    }
  }
}
</style>
